import moment from "moment";
import * as htmlToImage from "html-to-image";

const DivImage = async (files: any, Logo: any, props: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (files) {
        // Create a canvas element
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d", { willReadFrequently: true });

        if (!ctx) {
          throw new Error("Could not get canvas context");
        }

        // Load main image first to get its dimensions
        const mainImg = new Image();
        mainImg.crossOrigin = "anonymous";
        await new Promise((resolve, reject) => {
          mainImg.onload = () => resolve(true);
          mainImg.onerror = () =>
            reject(new Error("Failed to load main image"));
          mainImg.src = files;
        });

        // Calculate canvas dimensions with higher resolution
        const padding = 40; // Padding for header and footer
        const headerHeight = 150; // Space for logo
        const footerHeight = 80; // Space for text
        const imgWidth = 3000; // Increased base width for higher resolution output
        const imgHeight = (imgWidth * mainImg.height) / mainImg.width;

        // Set canvas size with header and footer
        canvas.width = imgWidth;
        canvas.height = headerHeight + imgHeight + footerHeight + padding * 2;

        // Enable high-quality rendering
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";

        // Fill white background
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw logo in header
        const logoImg = new Image();
        logoImg.crossOrigin = "anonymous";
        await new Promise((resolve, reject) => {
          logoImg.onload = () => {
            try {
              const logoWidth = canvas.width * 0.3;
              const logoHeight = (logoWidth * logoImg.height) / logoImg.width;
              ctx.drawImage(
                logoImg,
                (canvas.width - logoWidth) / 2,
                padding,
                logoWidth,
                logoHeight
              );
              resolve(true);
            } catch (error) {
              reject(error);
            }
          };
          logoImg.onerror = () => reject(new Error("Failed to load logo"));
          logoImg.src = Logo;
        });

        // Draw main image
        try {
          ctx.drawImage(
            mainImg,
            (canvas.width - imgWidth) / 2,
            headerHeight + padding+50,
            imgWidth,
            imgHeight
          );
        } catch (error) {
          console.error("Error drawing main image:", error);
          throw error;
        }

        // Add footer text with better font rendering
        ctx.fillStyle = "#000000";
        ctx.font = "bold 24px Arial"; // Increased font size for better readability
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(
          `${props?.edition} Edition`,
          canvas.width / 2,
          headerHeight + imgHeight + padding + 30
        );
        ctx.font = "20px Arial";
        ctx.fillText(
          `Date : ${moment(props?.date).format("l")} , Page : ${
            props?.page + 1
          }`,
          canvas.width / 2,
          headerHeight + imgHeight + padding + 60
        );

        // Convert to blob with maximum quality PNG format
        const blob = await new Promise<Blob>((resolve, reject) => {
          try {
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  resolve(blob);
                } else {
                  reject(new Error("Failed to create blob"));
                }
              },
              "image/png", // Changed from JPEG to PNG for better quality
              1.0
            );
          } catch (error) {
            reject(error);
          }
        });

        // Create file with proper MIME type
        let name = moment(new Date()).unix();
        let url = new File([blob], name + "-crop.png", {
          // Changed extension to .png
          type: "image/png", // Changed MIME type to PNG
          lastModified: new Date().getTime(),
        });

        // Convert to base64 with error handling
        let file = await blobToBase64(url);

        resolve(file);
      } else {
        resolve("error");
      }
    } catch (err) {
      console.error("Error in DivImage:", err);
      resolve("error");
    }
  });
};

const blobToBase64 = async (blob: any) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(blob);
    } catch (error) {
      reject(error);
    }
  });
};

export default DivImage;
